import { isATitleBox } from './boxes';

/**
 * Trouve l'id du titre "propriétaire" d'une box ou d'un container :
 * remonte les containers en arrière jusqu'à trouver un container qui contient une title box.
 */
export const findOwnerTitleId = ({ boxId, containerId, allBoxes, containers }) => {
  let targetContainer = containerId
    ? containers.find((c) => c.id === containerId)
    : null;

  if (!targetContainer && boxId) {
    const box = allBoxes.find((b) => b.id === boxId);
    if (box) {
      targetContainer = containers.find((c) => c.columnsIds.includes(box.columnId));
    }
  }

  if (!targetContainer) return null;

  const containerIdx = containers.findIndex((c) => c.id === targetContainer.id);

  for (let i = containerIdx; i >= 0; i--) {
    for (const colId of containers[i].columnsIds) {
      const titleBox = allBoxes.find((b) => b.columnId === colId && isATitleBox(b.type));
      if (titleBox) return titleBox.id;
    }
  }
  return null;
};

/**
 * Détecte directement la section liée depuis une box ou un container cliqué,
 * sans passer par le titre propriétaire (qui peut appartenir au template principal).
 */
export const getDirectLinkedSectionId = ({ boxId, containerId, allBoxes, containers }) => {
  if (boxId) {
    const box = allBoxes.find((b) => b.id === boxId);
    if (box?.fromSectionId) return box.fromSectionId;
    if (box) {
      const container = containers.find((c) => c.columnsIds.includes(box.columnId));
      if (container?.from_linked_section && container?.sectionId) return container.sectionId;
    }
  }
  if (containerId) {
    const container = containers.find((c) => c.id === containerId);
    if (container?.from_linked_section && container?.sectionId) return container.sectionId;
  }
  return null;
};

/**
 * Retourne l'id de section liée à surligner dans LinkedSections.
 * Utilise linkedSectionId (détecté directement) ou fromSectionId (depuis un titre de section liée cliqué dans Summary).
 */
export const getHighlightedLinkedSectionId = ({ selectedSummaryTitle }) => {
  return selectedSummaryTitle?.linkedSectionId || selectedSummaryTitle?.fromSectionId || null;
};

/**
 * Détermine si un nœud du Summary doit être surligné.
 * Seul le titre exactement sélectionné est mis en surbrillance.
 */
export const isSummaryTitleHighlighted = (node, { selectedSummaryTitle }) => {
  if (!selectedSummaryTitle) return false;
  return selectedSummaryTitle.key === node.key || selectedSummaryTitle.id === node.id;
};
